import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { model as travelModel,accidentmodel as accidentModel,petmodel as petModel,vaccineModel} from '@/utils/asyncValidator/insuFilterForm';
import { beneficiaryProfile,travelNoticeData } from '@/utils/asyncValidator/infoOfTravel';
import { inceptionDate as inceptionDateOfCar,autoNoticeData as autoNoticeDataOfCar ,carProfile as carProfileOfCar  } from '@/utils/asyncValidator/infoOfCar';
import { inceptionDate as inceptionDateOfMotor,autoNoticeData as autoNoticeDataOfMotor ,carProfile as carProfileOfMotor  } from '@/utils/asyncValidator/infoOfMotor';
import { accidentbeneficiaryProfile,accidentNoticeData ,healthNoticeData} from '@/utils/asyncValidator/infoOfAccident';
import { petNoticeData ,petHealthNoticeData} from '@/utils/asyncValidator/infoOfPet';
import { vaccineBeneficiaryProfile,vaccineNoticeData } from '@/utils/asyncValidator/infoOfVaccine';  //20200530 Wen add
         
const state = {
  loading: false,
  insuType: '',  
  insuInfos: [],
  infoOfTravel: {
    travelFilter: { 
      ...travelModel,
      travelArea: [{ state: null ,country: null}],
    },
    beneficiaryProfile: {
      ...beneficiaryProfile,
    },
    travelNoticeData: {
      ...travelNoticeData
    }    
  },
  infoOfCar: {
    inceptionDate: {
      ...inceptionDateOfCar
    },
    autoNoticeData: {
      ...autoNoticeDataOfCar
    },
    carProfile: {
      ...carProfileOfCar
    }  
  },
  infoOfMotor: {
    inceptionDate: {
      ...inceptionDateOfMotor
    },
    autoNoticeData: {
      ...autoNoticeDataOfMotor
    },
    carProfile: {
      ...carProfileOfMotor
    }  
  },
  infoOfAccident: {
    accidentFilter: { 
      ...accidentModel,
      //accidentArea: [{jobtype: null}],//[{ state: null ,job: null}],     
    },
    accidentbeneficiaryProfile: {
      ...accidentbeneficiaryProfile,
    },
    accidentNoticeData: {
      ...accidentNoticeData
    },
    healthNoticeData:{
      ...healthNoticeData
    }
  },
  infoOfPet: {
    petFilter: { 
      ...petModel,     
    },
    /*petBeneficiaryProfile: {
      ...petBeneficiaryProfile,
    },*/
    petNoticeData: {
      ...petNoticeData
    },
    petHealthNoticeData:{
      ...petHealthNoticeData
    }
  },
  infoOfVaccine: {
    vaccineFilter: { 
      ...vaccineModel     
    },
    vaccineBeneficiaryProfile: {
      ...vaccineBeneficiaryProfile,
    },
    vaccineNoticeData: {
      ...vaccineNoticeData
    }    
  },
  quotes: {
    total: "",
    InsuCompanyUrl:"",
    detail: [],
    prodPolicies: []
  },
  carInfo: {},
  travelInsuInfo: {
    travelArea: [],
    insuPeriod: ''
  },
  accidentInsuInfo: {
    //accidentArea: '',//[],{value:'',label:''}  //20210315
    AccidentinsuPeriod: ''//,
    //isbuy :''
  }, 
  petInsuInfo: {
     //20210415
    PetinsuPeriod: ''      
  },
  vaccineInsuInfo: {  //20210530 Wen Add
    VaccineinsuPeriod:''  
  } 
}


const checkout = {
  state,
  mutations,
  getters,
  actions
}

export default checkout;